import { GridApi, RowNode } from '@ag-grid-community/core';
import { ApolloQueryResult } from '@apollo/client';

import { formatTotalsFooter } from 'app/components/AdvancedGrid/GridHelpers/QuotaGrid/TotalsFooter/TotalsFooterHelper';

import { apolloClient } from 'app/containers/App/AuthApolloWrapper/AuthApolloWrapper';

import {
  TerritoryMeasures,
  TerritoryMeasuresTotals,
  GetTerritoryQuota,
  GetTerritoryQuotaTotals,
  TerritoryMeasuresTotalsVariables,
  TerritoryMeasuresVariables,
  GetTerritoryQuotaTotalsVariables,
  GetTerritoryQuotaTotals_getTerritoryQuota_periodicTotals
} from 'app/graphql/generated/apolloTypes';
import { UPSERT_MEASURE_VALUE } from 'app/graphql/mutations/upsertMeasureValue';

export const editMeasuresGridData = async (
  currentNode: RowNode,
  newValue: number,
  key: string,
  onUpdateMeasure: () => void
): Promise<boolean> => {
  const rowData = currentNode.data;
  const { battlecardId, territoryGroupId, territoryId, ruleId, quotaComponentId } = rowData;
  const measureId = rowData[key]?.id;
  const adate = rowData[key]?.date;

  try {
    // eslint-disable-next-line no-restricted-syntax
    await apolloClient.mutate({
      mutation: UPSERT_MEASURE_VALUE,
      variables: {
        input: {
          territoryId,
          territoryGroupId,
          battlecardId: +battlecardId,
          measureId,
          quotaComponentId,
          measureValue: Number(newValue),
          adate,
          ruleId
        }
      }
    });
    onUpdateMeasure();
  } catch (error) {
    console.log(error);
    return false;
  }

  return true;
};

const getGenericPeriodicTotals = (input: {
  data: TerritoryMeasuresTotals | GetTerritoryQuotaTotals;
}): GetTerritoryQuotaTotals_getTerritoryQuota_periodicTotals[] | null => {
  if (!input?.data) return null;
  if ('getTerritoryQuota' in input.data) return input.data.getTerritoryQuota?.periodicTotals;
  return null;
};

export const refetchRowData = async (
  variables: TerritoryMeasuresVariables,
  gridApi: GridApi,
  fetchMoreGroupMeasures: ({ variables }) => Promise<{
    data: TerritoryMeasures | GetTerritoryQuota;
  }>,
  refetchTerritoryGroupMeasuresTotals:
    | ((variables?: Partial<TerritoryMeasuresTotalsVariables>) => Promise<ApolloQueryResult<TerritoryMeasuresTotals>>)
    | ((variables?: Partial<GetTerritoryQuotaTotalsVariables>) => Promise<ApolloQueryResult<GetTerritoryQuotaTotals>>)
): Promise<boolean> => {
  const [refetchTerritoryMeasures, refetchTerritoryMeasuresTotals] = await Promise.all([
    fetchMoreGroupMeasures({ variables }),
    refetchTerritoryGroupMeasuresTotals()
  ]);
  const hasData = refetchTerritoryMeasures?.data && refetchTerritoryMeasures.data['getTerritoryQuota'];
  const newTotal = getGenericPeriodicTotals(refetchTerritoryMeasuresTotals);
  if (hasData && newTotal) {
    gridApi.refreshServerSideStore({ purge: false });

    const totals = formatTotalsFooter(newTotal);
    gridApi.setPinnedBottomRowData(totals);

    return true;
  }
  return false;
};
